export const SECRET_KEY = process.env.REACT_APP_SECRET_KEY || "secret";
export const API_INTEGRATION_ID = process.env.REACT_APP_INTEGRATION_ID || "";
